var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex w-screen"},[_c('side-nav',{staticClass:"w-24 h-screen py-10 sticky top-0 z-50"}),_vm._v(" "),_c('div',{staticClass:"min-h-screen",staticStyle:{"width":"calc(100vw)"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }